import SxDef from '@core/types/SxDef';
import menuScrollbar from '../scrollbar';

// Paper surface, radius and shadow come from the theme's MuiPopover pattern.
const useSx = (): SxDef => ({
  root: {
    // Header menus open just below the 64px navbar, whatever icon anchors them.
    '& .MuiMenu-paper': { top: '72px !important' },
    zIndex: 9000,
    '& .MuiPaper-root': {
      overflow: 'auto',
      overflowX: 'hidden',
      ...menuScrollbar,
    },
    '& .MuiMenu-list': {
      minWidth: '14rem',
    },
    '& .MuiDivider-root': {
      mx: -2,
      my: 1,
    },
  },
});

export default useSx;
